import { useCallback, useState } from 'react';
import { useApi } from './useApi';
import type { FileAttachment } from '@pantheon/shared';

export function useFileUpload() {
  const { post } = useApi();
  const [uploading, setUploading] = useState(false);

  const uploadFiles = useCallback(
    async (files: File[]): Promise<FileAttachment[]> => {
      setUploading(true);
      const results: FileAttachment[] = [];

      for (const file of files) {
        try {
          // Get presigned URL from API
          const presignResult = await post<{ uploadUrl: string; s3Key: string }>(
            '/upload',
            { fileName: file.name, mimeType: file.type || 'application/octet-stream' },
          );

          if (!presignResult.success || !presignResult.data) continue;

          const { uploadUrl, s3Key } = presignResult.data;

          // Upload directly to S3
          await fetch(uploadUrl, {
            method: 'PUT',
            body: file,
            headers: { 'Content-Type': file.type || 'application/octet-stream' },
          });

          results.push({
            s3Key,
            fileName: file.name,
            mimeType: file.type || 'application/octet-stream',
            size: file.size,
          });
        } catch (err) {
          console.error(`Failed to upload ${file.name}:`, err);
        }
      }

      setUploading(false);
      return results;
    },
    [post],
  );

  return { uploadFiles, uploading };
}
